const RareBoxLogoWhite = ({ width }) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width={width ?? 140} viewBox="0 0 300 71">
			<text x="0" y="65" font-family="Arial, sans-serif" font-size="60" fill="#FFFFFF">
				REL
			</text>

			<circle cx="135" cy="40" r="20" fill="none" stroke="#FFFFFF" stroke-width="5" />
			{/* <line x1="165" y1="60" x2="180" y2="75" stroke="#FFFFFF" stroke-width="5" stroke-linecap="round" /> */}
			<circle cx="184" cy="45" r="20" fill="none" stroke="#FFFFFF" stroke-width="5" />

			<text x="210" y="65" font-family="Arial, sans-serif" font-size="60" fill="#FFFFFF">
				K
			</text>
		</svg>
	);
};

export default RareBoxLogoWhite;
